import { CommonModule, registerLocaleData } from '@angular/common';
import { Injectable, NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '@src/app/app-routing.module';
import { HotelnameService } from 'src/app/services/hotelname.service';
import { FlightSearchEffects } from './store/flight-search/flight-search.effects';
import { metaReducers, reducers } from './store/selectors';

import { AppComponent } from '@src/app/app.component';

import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { MatListModule } from '@angular/material/list';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule, SwRegistrationOptions } from '@angular/service-worker';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as Hammer from 'hammerjs';
import { environment } from '../environments/environment';
import { CoreModule } from './core/core.module';
import { SharedUiModule } from './shared-ui/shared-ui.module';
import { AuthModule } from './users/auth.module';
import * as fromState from './store';
import { OffersEffects } from './store/app-offers/offers.effects';
import { AppSettingEffects } from './store/app-setting/app-setting.effects';
import { AppUtilitiesEffects } from './store/app-utilities/app-utilities.effects';
import { HotelSearchEffects } from './store/hotel-search/hotel-search.effects';
import { UserEffects } from './store/user/user.effects';


import * as fromOffers from './store/app-offers/offers.reducer';
import * as fromSettings from './store/app-setting/app-setting.reducer';
import * as fromUtilities from './store/app-utilities/app-utilities.reducer';
import * as fromFlights from './store/flight-search/flight-search.reducer';
import * as fromUser from './store/user/user.reducer';

import { AuthInterceptorService } from './interseptor/auth-interceptor.service';
import { FlightServiceService } from './services/flight-service.service';

import localeAr from '@angular/common/locales/ar-EG';
import arSaLocale from '@angular/common/locales/ar-SA';
import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthService, SocialAuthServiceConfig, SocialLoginModule } from 'angularx-social-login';
import { GoogleTagManagerModule } from 'angular-google-tag-manager';

registerLocaleData(arSaLocale)
registerLocaleData(localeAr)

@Injectable({
  providedIn: 'root'
})
export class HammerConfig extends HammerGestureConfig {
  overrides = {
    swipe: { direction: Hammer.DIRECTION_ALL },
  };
}

const googleLoginOptions = {
  scope: 'profile email',
  plugin_name:'login' //you can use any name here
};
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent

  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    CommonModule,
    SocialLoginModule,
    MatListModule,
    MatIconModule,
  
    FontAwesomeModule,
    TranslateModule.forRoot({
      defaultLanguage: 'ar',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
    },
    
  }),
  ServiceWorkerModule.register('src/ngsw-worker.js'),
    GoogleTagManagerModule.forRoot({
      id: 'GTM-W7QX3QZX'
    }),
    MatIconModule,
    StoreModule.forRoot(reducers, {
      metaReducers, 
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      }
    }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    StoreModule.forFeature(fromFlights.flightSearchFeatureKey, fromFlights.reducer),
    StoreModule.forFeature(fromUtilities.appUtilitiesFeatureKey, fromUtilities.reducer),
    StoreModule.forFeature(fromSettings.appSettingFeatureKey, fromSettings.reducer),
    StoreModule.forFeature(fromUser.userFeatureKey, fromUser.reducer),
    StoreModule.forFeature(fromOffers.appOffersFeatureKey, fromOffers.reducer),
    HammerModule,

    CoreModule,
    SharedUiModule,
    AuthModule,
    StoreModule.forFeature(fromState.stateFeatureKey, fromState.reducers, { metaReducers: fromState.metaReducers }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    EffectsModule.forRoot([AppUtilitiesEffects, OffersEffects,AppSettingEffects, HotelSearchEffects, UserEffects,FlightSearchEffects])
  ],
  
  providers: [
    // {
    //   provide: NgbDatepickerI18n,
    //   useClass: DatepickerI18nService,
    //   deps: [TranslateService], // Include the TranslateService dependency
    // },
    FlightServiceService,
    {
    provide: SwRegistrationOptions,
    useFactory: () => ({ enabled: environment.production }),
   
  }, {
    
    provide: HAMMER_GESTURE_CONFIG,
    useClass: HammerConfig
  },HotelnameService ,  {
    provide: HTTP_INTERCEPTORS,
    useClass: AuthInterceptorService,
    multi: true
  },
{
  provide:'SocialAuthServiceConfig',
  useValue:{
    autoLogin:false,
    providers:[
      {
        id:FacebookLoginProvider.PROVIDER_ID,
        provider:new FacebookLoginProvider("3481677202157637")
      },
      {
        id:GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider('829934546921-lghc6mhmb5jod382m6nkh82hbiuong5j.apps.googleusercontent.com', googleLoginOptions)
      }
    ],
    onError:(err) =>{console.log(err)},
  } as SocialAuthServiceConfig
},SocialAuthService,




],
  bootstrap: [AppComponent],
})
export class AppModule { }

